<template>
  <div class="inline-flex items-center">
    <!-- Hidden native color input -->
    <input
      ref="picker"
      type="color"
      class="sr-only"
      :value="modelValue"
      :disabled="disabled"
      @input="onPick"
    />

    <core-tooltip :text="tooltipText">
      <button
        type="button"
        :disabled="disabled"
        :aria-label="ariaLabel"
        @click="openPicker"
        :style="buttonStyle"
        class="relative inline-grid place-items-center size-10 rounded-full
             shadow-sm ring-1 ring-black/20 transition
             hover:scale-[1.03] active:scale-[0.98]
             focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/30
             disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:active:scale-100"
      >
        <!-- Inner cutout (always present to keep the ring look) -->
        <span class="absolute inset-[8px] rounded-full bg-white dark:bg-charcoal-900"></span>

        <span class="relative text-xl font-semibold leading-none text-black dark:text-white select-none">+</span>
      </button>
    </core-tooltip>

  </div>
</template>

<script setup>
  const props = defineProps({
    modelValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    ariaLabel: { type: String, default: 'Choose color' },
  });

  const emit = defineEmits([
    'update:modelValue'
  ]);

  const picker = ref(null);

  const hasColor = computed(() => !!props.modelValue);

  const openPicker = () => {
    if (props.disabled) return;
    picker.value?.click();
  };

  const onPick = (e) => {
    const next = e.target.value;
    emit('update:modelValue', next);
  };

  const buttonStyle = computed(() => {
    // Default rainbow ring when no color selected
    if (!hasColor.value) {
      return {
        background:
          'conic-gradient(from 0deg, #ff3b30, #ffcc00, #34c759, #00c7be, #0a84ff, #5856d6, #ff2d55, #ff3b30)',
      };
    }

    // Selected ring color
    return { background: props.modelValue };
  });

  const tooltipText = computed(() => {
    if (!hasColor.value) return 'Select custom color';
    return props.modelValue;
  });

</script>
